module.exports = __webpack_public_path__ + "static/media/big-gallery-2.34c6010a.jpg";